// =====================================================================
//  Contenido centralizado de LoremiG Party — Aesthetic Edition
//  Edita aquí los textos / datos sin tocar los componentes.
// =====================================================================

export const NAV = [
  { href: "#quienes", label: "Quiénes Somos", c: "fucsia" },
  { href: "#brujula", label: "Visión & Misión", c: "turquesa" },
  { href: "#calendario", label: "Calendarización", c: "naranja" },
  { href: "#menu", label: "Menú", c: "lima" },
  { href: "#galeria", label: "Galería", c: "morado" },
  { href: "#contacto", label: "Contacto", c: "rosa" },
];

export const HERO = {
  eyebrow: "Fiestas Infantiles · CDMX · est. 2026",
  titleTop: "LoREMi Grand",
  titleItal: "PARTY HALL",
  welcomeName: "LoREMi G",
  lead: "Momentos que comienzan con una ilusión y se convierten en recuerdos para toda la vida.",
  para0Before: "En ",
  para0After:
    " nos encanta celebrar en grande — creemos que cada etapa de nuestros peques merece su " +
    "propia fiesta. Por eso armamos un espacio lleno de color y magia, listo para acompañarte " +
    "desde la gran noticia de su llegada hasta cada uno de esos momentos que marcan su infancia.",
  paras: [
    "Aquí podrás celebrar un gender reveal, su cumpleaños, una graduación, su Primera Comunión " +
      "y todos aquellos momentos que quieras convertir en un recuerdo inolvidable.",
    "Un lugar creado para disfrutar, celebrar y compartir en familia, donde cada detalle está " +
      "pensado para que tú solo tengas que preocuparte por una cosa: vivir y disfrutar el momento.",
  ],
  tag: "— porque hay momentos que pasan una vez… y recuerdos que permanecen para siempre —",
  tickets: [
    { n: "+520", t: "fiestas celebradas" },
    { n: "4.9 ★", t: "reseñas verificadas" },
    { n: "12", t: "temáticas disponibles" },
    { n: "2", t: "salones equipados" },
  ],
};

export const QUIENES = {
  leadHtml:
    "LoremiG es el resultado de un sueño compartido entre cuatro socios que decidimos unir " +
    "nuestra visión, pasión y entusiasmo para crear un lugar diferente.",
  paras: [
    "Un espacio diseñado para acompañar los momentos que se convierten en parte de nuestra " +
      "historia: desde las primeras celebraciones de los más pequeños hasta todos aquellos " +
      "acontecimientos que merecen ser recordados.",
    "En LoremiG creemos que la verdadera magia está en compartir, celebrar y crear recuerdos " +
      "que permanezcan para siempre.",
  ],
  caption: '"Porque hay momentos que pasan una vez… y recuerdos que permanecen para siempre"',
};

export const MISION = {
  title: "Misión",
  text:
    "En Loremi Grand Party Hall creamos experiencias inolvidables para las familias, " +
    "ofreciendo eventos llenos de amor, seguridad y calidad. Nuestro compromiso es brindar un " +
    "ambiente cálido y confiable, donde cada celebración se viva como en casa, acompañada de " +
    "alimentos deliciosos, atención cercana y momentos que permanezcan en el corazón de " +
    "nuestros clientes.",
};

export const VISION = {
  title: "Visión",
  text:
    "Ser el salón de fiestas infantiles más querido y reconocido de la Ciudad de México por " +
    "crear experiencias mágicas y seguras para toda la familia, distinguiéndonos por nuestra " +
    "calidad y calidez humana y servicio excepcional, haciendo que cada evento se viva con la " +
    "comodidad y alegría de un verdadero hogar.",
};

export const VALORES = [
  { ico: "♡", title: "Amor", text: "Ponemos cariño y dedicación en cada detalle de cada celebración." },
  { ico: "⛨", title: "Seguridad", text: "Creamos espacios confiables y protegidos para niños y familias." },
  { ico: "✦", title: "Calidad", text: "Cuidamos cada servicio, alimento y experiencia para superar expectativas." },
  { ico: "⌂", title: "Familia", text: "Fomentamos momentos de unión, convivencia y felicidad entre seres queridos." },
  { ico: "✿", title: "Experiencia", text: "Diseñamos eventos memorables que dejan recuerdos especiales." },
  { ico: "★", title: "Excelencia", text: "Alimentos preparados con sabor, amor, presentación y excelencia." },
  { ico: "☼", title: "Hogar", text: "Queremos que cada cliente se sienta cómodo, bienvenido y en confianza." },
  { ico: "✓", title: "Compromiso", text: "Trabajamos con responsabilidad y atención a cada necesidad." },
  { ico: "✧", title: "Magia", text: "Transformamos cada evento en un momento único e inolvidable." },
];

// ---- Calendario ----
export const MONTHS_T = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
];

// Fechas ocupadas / promociones (mock). Conecta esto a tu API más adelante.
// clave = `${año}-${mesIndex}`  (mesIndex 0-based: Mayo = 4)
export const BOOKED = { "2026-5": [2, 9, 16, 23, 30], "2026-6": [6, 13, 20], "2026-4": [3, 10, 17, 24] };
export const FEATURED = { "2026-5": [24, 31], "2026-6": [14, 21, 28], "2026-7": [5, 12] };

export const TEMAS = [
  { key: "cumpleanos", label: "Cumpleaños" },
  { key: "babyshower", label: "Baby shower" },
  { key: "graduacion", label: "Graduación" },
  { key: "comunion", label: "Primera comunión" },
  { key: "otro", label: "Otro evento" },
];

export const PROXIMOS = [
  { d: 24, m: 4, title: "Presentación · Productos de Belleza", sub: "Evento abierto · entrada libre" },
  { d: 24, m: 1, title: "Día del Amor y la Amistad", sub: "Evento abierto · cupo 60" },
  { d: 14, m: 5, title: "Día del Padre · Open Salón", sub: "Evento abierto · cupo 60" },
];

// ---- Galería ----
// Cada categoría es un carrusel de fotos; las imágenes reales viven en
// Galeria.jsx (import + arreglo por `key`).
export const GALLERY = [
  { key: "fachada", title: "Fachada", kicker: "la entrada que enamora" },
  { key: "areaJuegos", title: "Área de juegos", kicker: "diversión sin límites" },
  { key: "interiores", title: "Interiores", kicker: "espacios pensados para celebrar" },
  { key: "areaComida", title: "Área de comida", kicker: "buen sabor, buena compañía" },
];

// ---- Menú ----
export const MENU_INTRO =
  "Un banquete pensado con el mismo cariño que ponemos en cada fiesta — para grandes y chiquitos.";

export const INCLUIDO = [
  "Menú de adultos", "Menú infantil", "Botana de bienvenida", "Barra de ensalada gourmet",
  "Piñata con dulces", "Pastel decorado", "Bebidas ilimitadas", "Invitaciones digitales",
  "Nanitas de apoyo", "Meseros", "Mobiliario y equipo", "Minisúper de dulces",
  "Arcade Zone", "Playground", "Tirolesa", "Pinta carita",
];

export const COMIDA_ADULTOS = [
  {
    title: "Costillitas BBQ",
    text: "Tiernas costillitas de cerdo bañadas en salsa BBQ, acompañadas de papas a la francesa y elote dulce.",
    incluye: "Ensalada fresca con aderezo César.",
  },
  {
    title: "Hamburguesas a la Parrilla",
    text: "Jugosa hamburguesa de Rib Eye a la parrilla con papas a la francesa. Queso a elegir: Oaxaca o Cheddar.",
    incluye: "Barra de ensaladas · extra de tocino (+$10 por persona).",
  },
  {
    title: "Baguettes Artesanales",
    text: "Preparados con lechuga, jitomate, cebolla caramelizada, aceite de oliva extra virgen y reducción de balsámico.",
    list: [
      "Atún · ensalada de atún, apio y lechuga fresca",
      "Jamón serrano · queso gouda y vegetales frescos",
      "Jamón o pechuga de pavo · queso manchego y vegetales frescos",
      "Salmón ahumado · queso crema y alcaparras",
    ],
  },
  {
    title: "Parrillada",
    text: "Elige hasta 4 especialidades: cecina, carne al pastor, chorizo, costilla, bistec, arrachera o alambre de pollo.",
    incluye: "Cebollitas cambray asadas y barra de ensaladas.",
  },
  {
    title: "Estación Italiana",
    text: "Arma tu plato: pasta (fettuccine, spaghetti o fusilli) + salsa (boloñesa, Alfredo o crema) + proteína (pollo o albondiguitas de res).",
    incluye: "Mini pan artesanal · extra de camarones (+$35 por persona).",
  },
  {
    title: "Taquiza",
    text: "Elige hasta 4 guisados: mole con pollo, chicharrón en salsa verde o roja, tinga, cochinita pibil, bistec a la mexicana, cerdo en salsa morita, papas con chorizo, rajas con crema o picadillo de res.",
    incluye: "Tortillas recién hechas, arroz, frijoles y barra de ensaladas.",
  },
];

export const COMIDA_INFANTIL = [
  {
    title: "Boneless",
    text: "Crujientes boneless de pollo en versión BBQ o naturales, con papas a la francesa.",
    incluye: "Elotito, bastones de zanahoria, jícama y pepino.",
  },
  {
    title: "Tacos Dorados",
    text: "Tradicionales tacos dorados de pollo o res, preparados al momento.",
    incluye: "Sopa de fideos y ensalada verde o bastones de jícama y zanahoria.",
  },
  {
    title: "Milanesa o Pechuga",
    text: "Milanesa de pollo o res, o pechuga a la plancha, con puré de papa cremoso.",
    incluye: "Ensalada verde o bastones de jícama y zanahoria.",
  },
  {
    title: "Mini Italiano",
    text: "Pasta en salsa boloñesa o Alfredo, con pollo a la plancha o mini albóndigas de res.",
    incluye: "Mini pan artesanal y ensalada verde o bastones de jícama y zanahoria.",
  },
];

export const BARRAS = [
  {
    title: "Barra de Ensaladas Gourmet",
    note: "incluida en cualquier opción de menú",
    text: "Ingredientes frescos para que cada invitado arme su ensalada a su gusto.",
    list: [
      "Base: lechuga, espinaca, pepino, champiñones, zanahoria, jícama, germen y jitomate cherry",
      "Extras: arándanos deshidratados y nueces",
      "Aderezos: miel con mostaza Dijon · balsámico con oliva · yogurt griego con aguacate · limón y sal",
      "Toppings premium (+$15 p.p.): aguacate, queso panela, queso de cabra o parmesano",
    ],
  },
  {
    title: "Barra de Fruta Gourmet",
    note: "sustituye la barra de ensaladas en eventos de desayuno, sin costo",
    text: "Fruta fresca de temporada, jugo natural y una pieza de pan dulce.",
    list: [
      "Fruta fresca y jugo natural de temporada",
      "1 pieza de pan dulce por persona",
      "Complementos premium (+$15 p.p.): yogurt natural, queso cottage, granola o amaranto",
    ],
  },
];

// dirección en texto plano, usada para armar el link/embed de Google Maps (sin API key)
export const MAP_ADDRESS =
  "Av. Universidad No. 32, Col. Narvarte Oriente, Alcaldía Benito Juárez, CDMX";

export const CONTACTO_INFO = [
  { ico: "☎", cls: "s", lbl: "Teléfono & WhatsApp", value: "+52 56 10 08 9073" },
  { ico: "✉", cls: "", lbl: "Correo", value: "contactoloremig@loremig.com" },
  { ico: "instagram", cls: "m", lbl: "Instagram", value: "@loremi_g_" },
  { ico: "⌂", cls: "i", lbl: "Estudio", value: "Av. Universidad No. 32, Col. Narvarte Oriente,<br/>Alcaldía Benito Juárez, CDMX" },
  { ico: "◷", cls: "s", lbl: "Horario de oficina", value: "Mar – Sáb · 10:00 a 19:00" },
];
